import { type UserRoleProps } from '@/services/types/userRoles/mockUserRoles'
import { api } from './api'
import { endpoints } from './endpoints'

export interface CreateFullAccountRoleProps {
  roleId: string
  userId: string
}
export interface CreateRoleWithScopeProps extends CreateFullAccountRoleProps {
  scope: { folderIds?: string[]; storeIds?: string[] }
}

export interface UpdateFullAccountRoleProps extends CreateFullAccountRoleProps {
  id: string
}
export interface UpdateRoleWithScopeProps extends CreateRoleWithScopeProps {
  id: string
}

export const rolesService = {
  async createFullAccountRole(data: CreateFullAccountRoleProps) {
    return api.post(`${endpoints.roles.userRoles}`, data)
  },
  async createRoleWithScope(data: CreateRoleWithScopeProps) {
    return api.post(`${endpoints.roles.userRoles}`, data)
  },
  async deleteRole(id: string) {
    return api.delete(`${endpoints.roles.userRoles}/${id}`)
  },
  async getAllRoles() {
    return api.get<UserRoleProps[]>(`${endpoints.roles.userRoles}`)
  },
  async getRolesByUser(userId: string) {
    const params: { userIds: string[] } = {
      userIds: [userId],
    }
    return api.get<UserRoleProps[]>(`${endpoints.roles.userRoles}`, {
      params,
      paramsSerializer: {
        indexes: false,
      },
    })
  },
  async updateFullAccountRole({ id, ...data }: UpdateFullAccountRoleProps) {
    return api.put(`${endpoints.roles.userRoles}/${id}`, data)
  },
  async updateRoleWithScope({ id, ...data }: UpdateRoleWithScopeProps) {
    return api.put(`${endpoints.roles.userRoles}/${id}`, data)
  },
}
